/**
 * Build identity (#1304). `__APP_VERSION__` / `__APP_BUILD_TIME__` are
 * injected by `define` in vite.config.ts (git short SHA + ISO build time) and
 * vitest.config.ts. Fallbacks keep dev servers and tests working.
 */
declare const __APP_VERSION__: string | undefined;
declare const __APP_BUILD_TIME__: string | undefined;

export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'string' && __APP_VERSION__ ? __APP_VERSION__ : 'dev';
export const APP_BUILD_TIME: string =
  typeof __APP_BUILD_TIME__ === 'string' && __APP_BUILD_TIME__ ? __APP_BUILD_TIME__ : 'unknown';

interface DiagnosticsInput {
  userAgent: string;
  online: boolean;
  pathname: string;
  now?: Date;
}

/** Paste-ready block for support tickets. Contains no user or firm identifiers. */
export function buildDiagnostics({ userAgent, online, pathname, now = new Date() }: DiagnosticsInput): string {
  return [
    'MyCaseMgr diagnostics',
    `version: ${APP_VERSION}`,
    `build: ${APP_BUILD_TIME}`,
    `time: ${now.toISOString()}`,
    `route: ${pathname}`,
    `online: ${online}`,
    `userAgent: ${userAgent}`,
  ].join('\n');
}

export function collectBrowserDiagnostics(
  // Injected browser surfaces keep this util free of direct DOM globals.
  nav: Pick<Navigator, 'userAgent' | 'onLine'> | undefined = globalThis.navigator,
  loc: Pick<Location, 'pathname'> | undefined = globalThis.location,
): string {
  return buildDiagnostics({
    userAgent: nav?.userAgent ?? 'unknown',
    online: nav?.onLine ?? true,
    pathname: loc?.pathname ?? '/',
  });
}
